import React from 'react'
import Navbar from '../Home/Navbar';
import Footer from '../Home/Footer';
import HeaderAbout from './HeaderAbout';
import MainAbout from './MainAbout';
import Brand from './Brand';
import { CartProvider } from 'react-use-cart';

function AllAbout() {
  return (
    <CartProvider>
        <Navbar/>
        <br/>
        <br/>
        <HeaderAbout/>
        <MainAbout/>
        <Brand/>
        <Footer/>
    </CartProvider>
  )
}

export default AllAbout;